<template lang="pug">
div
  sticky(className="sub-navbar")
    el-button(type='primary' size='mini' icon='el-icon-upload' @click='onSave') 保存
    template(v-if='getPageType() !== "create"')
      el-button(type='warning' size='mini' icon='el-icon-view' native-type='submit' @click="preview('ja')") プレビュー
    el-button(v-if='getPageType() !== "create"' size='mini' type='danger' icon='el-icon-delete' @click='onDelete') 削除
  .contents-container
    el-form.c-form(ref='form', :model='form', :rules='rules', v-loading='LOADING')
      header.c-form__header
        h1 必須項目
      .c-form__body(v-if='dataloaded')
        section.c-form__item
          header.c-form__item__header.--c.--top
            h1 名前
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.name.ja' placeholder='名前を入力してください')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.name.en' placeholder='名前を入力してください')

        section.c-form__item
          header.c-form__item__header
            h1 ID
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                el-form-item(prop="key")
                  el-input(v-model='form.key' placeholder='IDを入力してください')
                  p.caption URLに使われます。半角英数記号(_)のキャメルケースで入力してください。(e.g: emprire_of_the_sun)

        section.c-form__item
          header.c-form__item__header
            h1 ステータス
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  el-select(v-model='form.status')
                    el-option(v-for='item in OPTIONS.status', :key='item.value', :label='item.label', :value='item.value')

        section.c-form__item
          header.c-form__item__header.--c
            h1 肩書き
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.title.ja' placeholder='肩書きを入力してください')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.title.en' placeholder='肩書きを入力してください')

        section.c-form__item
          header.c-form__item__header.--c
            h1 説明文
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item(label='日本語')
                  el-input(v-model='form.description.ja' placeholder='説明文を入力してください' type='textarea' :rows='10')
              el-col(:span='12')
                el-form-item(label='英語')
                  el-input(v-model='form.description.en' placeholder='説明文を入力してください' type='textarea' :rows='10')

        section.c-form__item
          header.c-form__item__header
            h1 プロフィール画像
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='12')
                el-form-item
                  upload-single(:form='form' datakey='profile_image' ratio='1_1')

        section.c-form__item
          header.c-form__item__header
            h1 関連作品
            .func
              el-button(size='small' type='primary' icon='el-icon-plus' @click='showAddWorksModal()'  :disabled='form.related_portfolio.length > 3') Works追加
              el-button(size='small' type='danger' icon='el-icon-delete' @click='deleteFeature()' :disabled='form.related_portfolio.length < 1') 削除
          .c-form__item__body
            el-row(:gutter='20')
              el-col(:span='24')
                draggable.c-list__works(v-model='form.related_portfolio' element='ul')
                  li(v-for='(i, index) in form.related_portfolio' :key='index')
                    template(v-if='getWorkImageUri(form.related_portfolio[index])')
                      img.c-thumb__item--s(:src='getWorkImageUri(form.related_portfolio[index])')
                    template(v-else)
                      .c-thumb__item--s
                        p no image
                    | {{getWorkString(form.related_portfolio[index])}}
            el-row(:gutter='20')
              el-col(:span='12')
                p.caption.u-margin__top--s 最大四件設定、ステータスが非公開の場合は表示されません。
  modal-add-works-element(:visible='modalvisible.works' @hideModal='hideWorksModal')
</template>

<script type='text/javascript'>
import form from '@/mixins/form'
import Sticky from '@/components/Element/Sticky'
import UploadSingle from '@/components/Element/Upload/Single'
import UploadMulti from '@/components/Element/Upload/Multi'
import ModalAddWorksElement from '@/components/Element/Modal/AddWorksElement'
import draggable from 'vuedraggable'
export default {
  name: 'PagesTalentDetail',
  mixins: [form],
  data () {
    return {
      modalvisible: {
        works: false
      },
      index: null,
      rules: {
        key: [{ required: true, message: 'IDは必須です', trigger: 'blur' }]
      },
      initialForm: null, // 初期値
      form: {
        id: null,
        key: null,
        status: 0,
        name: {
          ja: null,
          en: null
        },
        title: {
          ja: null,
          en: null
        },
        description: {
          ja: null,
          en: null
        },
        main_images: {
          item_type: 'images',
          images: []
        },
        profile_image: {
          id: null,
          uri: null
        },
        thumbnail: {
          square: null,
          rectangle: null
        },
        related_portfolio: []
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    showAddWorksModal () {
      this.modalvisible.works = true
    },
    /**
     * @param {Object} data
     */
    hideWorksModal (data) {
      this.modalvisible.works = false
      if (data.id) {
        // 最後に追加
        this.form.related_portfolio.push({
          type: 'work',
          id: data.id
        })
      }
      this.index = null
    },
    /**
     * @param {Object} data
     */
    hideArtModal (data) {
      this.modalvisible.art = false
      if (data.id) {
        this.form.related_portfolio[this.index] = {
          type: 'art',
          id: data.id
        }
      }
      this.index = null
    },
    /**
     * フィーチャーを削除
     */
    deleteFeature () {
      // 最後の要素から削除
      this.form.related_portfolio.pop()
    },
    hasUnsavedChanges () {
      return JSON.stringify(this.form) !== JSON.stringify(this.initialForm)
    },
    validation () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.onSave()
        } else {
          this.$message.error('入力内容に誤りがあります。')
          return false
        }
      })
    },
    preview (lang) {
      const openPreviewWindow = (lang) => {
        const path = lang === 'ja' ? '' : 'en/'

        const currentHost = location.hostname

        let previewBaseUrl

        if (currentHost === 'w0w-2024-cms.s2factory.co.jp') {
          previewBaseUrl = 'https://w0w-2024-www.s2factory.co.jp'
        } else if (currentHost === 'cms.w0w.co.jp') {
          previewBaseUrl = 'https://www.w0w.co.jp'
        } else {
          // デフォルト（予期しないホストの場合）
          previewBaseUrl = 'https://www.w0w.co.jp'
        }

        const url = `${previewBaseUrl}/${path}draft/talents/${this.form.key}`
        window.open(url, '_blank')
      }
      if (this.hasUnsavedChanges()) {
        this.$confirm('未保存の変更があります。保存せずにプレビューしますか？', '確認', {
          confirmButtonText: 'はい',
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(() => {
          openPreviewWindow(lang)
        }).catch(() => {
        // キャンセルされた場合は何もしない
        })
      } else {
        openPreviewWindow(lang)
      }
    }
  },
  watch: {
    'form.main_images': function (nv, ov) {
      if (!Object.keys(nv).length) {
        this.form.main_images = ov
      }
    }
  },
  components: {
    Sticky,
    UploadSingle,
    UploadMulti,
    ModalAddWorksElement,
    draggable
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Talent/Detail/index.vue